import { skipToken, useQuery } from "@apollo/client/react";

import { AccountBalancesDocument } from "@/graphql/codegen/graphql";
import type { Maybe, PartialAccount } from "@/utils/types";

export const useCCBalance = (
  account: Maybe<PartialAccount>,
  userPublicKey: string,
) => {
  const { publicKey: ccPublicKey } = account || {};
  const {
    data: ccBalanceResponse,
    loading: loadingCCBalance,
    refetch,
  } = useQuery(
    AccountBalancesDocument,
    userPublicKey && ccPublicKey
      ? {
          fetchPolicy: "network-only",
          variables: {
            publicKey: userPublicKey,
            filter: {
              creator: {
                publicKey: {
                  equalTo: ccPublicKey,
                },
              },
              isDaoCoin: {
                equalTo: true,
              },
            },
          },
        }
      : skipToken,
  );

  return {
    ccBalanceNanos:
      ccBalanceResponse?.accountByPublicKey?.tokenBalances?.nodes?.[0]
        ?.balanceNanos || "0",
    loading: loadingCCBalance,
    refetch,
  };
};
